import styled from 'styled-components';

export const SearchContainer = styled.div`
  height: fit-content;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.grayExtraLight};
  border: 1px solid ${({theme}) => theme.grayLightest};
  border-radius: 8px;
  transition: all 300ms ease-in-out;
  margin-right: 30px;
  :focus-within{
    border-color: ${({theme}) => theme.accent};
  }
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
    justify-content: start;
    margin-right: 10px;
  }
`

export const SearchInput = styled.input`
    width: 100%;
    border: unset;
    padding: 12px 12px;
    ::placeholder {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.3px;
      color: ${({theme}) => theme.grayDark};
      opacity: 0.4;
    }
`
